import { Chat } from "@/types";

import { axios } from "../axios.instance";

export type MuteChatRequest = {
  chatId: string;
};

export type MuteChatResponse = Chat;

export const muteChat = async (body: MuteChatRequest): Promise<MuteChatResponse> => {
  const { data } = await axios.post(`/chats/${body.chatId}/mute`);

  return data;
};
